import { useEffect } from 'react'
import { createRoot } from 'react-dom/client'

import { useDocumentLoaded } from '@f-fertighaus/utils/useDocumentLoaded'

const adsDefaultDimensions = {
  skyscraper: [160, 600],
  superbanner: [728, 90],
  hausbau: [300, 250]
}

interface BannerAdsProps {
  skyscraperId?: string
  superbannerId?: string
  hausbauId?: string
}

function createAdElement(dimensions: [number, number], adElementId?: string) {
  if (!adElementId) {
    return null
  }
  const [width, height] = dimensions

  const adElement = document.createElement('div')
  adElement.setAttribute('id', adElementId)
  adElement.style.minWidth = width + 'px'
  adElement.style.minHeight = height + 'px'

  return adElement
}

const BannerAds = (props: BannerAdsProps) => {
  const documentLoaded = useDocumentLoaded()

  useEffect(() => {
    if (!documentLoaded || !window.googletag) {
      return
    }

    const skyscraperElement = createAdElement(
      adsDefaultDimensions.skyscraper,
      props.skyscraperId
    )
    const superbannerElement = createAdElement(
      adsDefaultDimensions.superbanner,
      props.superbannerId
    )
    const hausbauElement = createAdElement(
      adsDefaultDimensions.hausbau,
      props.hausbauId
    )

    if (window.googletag.apiReady) {
      window.googletag.cmd.push(function () {
        if (skyscraperElement) {
          window.googletag
            .defineSlot(
              '/46859844/Bauen.de_Skyscraper',
              [adsDefaultDimensions.skyscraper, [300, 600]],
              props.skyscraperId
            )
            .addService(window.googletag.pubads())
        }

        if (superbannerElement) {
          window.googletag
            .defineSlot(
              '/46859844/Bauen.de_Superbanner',
              adsDefaultDimensions.superbanner,
              props.superbannerId
            )
            .addService(window.googletag.pubads())
        }

        if (hausbauElement) {
          window.googletag
            .defineSlot(
              '/46859844/Immowelt.de_Hausbau_Medium_Rectangle',
              adsDefaultDimensions.hausbau,
              props.hausbauId
            )
            .addService(window.googletag.pubads())
        }
        window.googletag.pubads().enableSingleRequest()
        window.googletag.enableServices()
        window.googletag.cmd.push(function () {
          props.skyscraperId && window.googletag.display(props.skyscraperId)
          props.superbannerId && window.googletag.display(props.superbannerId)
          props.hausbauId && window.googletag.display(props.hausbauId)
        })
      })
    }
  }, [documentLoaded])

  return (
    <div className='IM-ADS_container'>
      {props.skyscraperId && (
        <div id={props.skyscraperId} className='IM-ADS_skyscraper' />
      )}
      {props.superbannerId && (
        <div id={props.superbannerId} className='IM-ADS_superbanner' />
      )}
      {props.hausbauId && (
        <div id={props.hausbauId} className='IM-ADS_hausbau' />
      )}
    </div>
  )
}

const mountPoint = document.querySelector('#im-ads') as HTMLElement
if (mountPoint) {
  const root = createRoot(mountPoint)
  const skyscraperId = mountPoint.dataset.skyscraperId
  const superbannerId = mountPoint.dataset.superbannerId
  const hausbauId = mountPoint.dataset.hausbauId

  root.render(
    <BannerAds
      skyscraperId={skyscraperId}
      superbannerId={superbannerId}
      hausbauId={hausbauId}
    />
  )
}
